<template>
  <h2 class="section-sub-title" :class="rootClasses">
    <div v-scroll-reveal.reset="{ distance: '240px', origin: 'left' }" class="separator"></div>
    <slot />
  </h2>
</template>

<script>
export default {
  name: 'SectionTitle',

  props: {
    white: Boolean,
    fullWidth: Boolean,
  },

  computed: {
    rootClasses() {
      return {
        'is-white': this.white,
        'full-width': this.fullWidth,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
h2 {
  position: relative;
  width: 100%;
  font-weight: 400;
  color: $--color--font-2;
  line-height: 1.5;
  margin: 0;
  padding-top: 30px;
  margin-bottom: 60px;
  @include font-size(35px);

  &.is-white {
    color: #fff;
  }
  &.full-width {
    width: 100%;
  }

  @include respond-to('medium') {
    width: 80%;
  }
  @include respond-to('large') {
    width: 70%;
  }
}

.separator {
  position: absolute;
  top: 0px;
  height: 3px;
  width: 60px;
  background-color: $--color--primary;
}
</style>
